import { render, staticRenderFns } from "./photo-video.vue?vue&type=template&id=42166b1b&"
import script from "./photo-video.vue?vue&type=script&lang=js&"
export * from "./photo-video.vue?vue&type=script&lang=js&"
import style0 from "./photo-video.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports